import { ChangeEventHandler, ReactNode, useCallback, useState } from 'react'
import { AriaTextFieldOptions } from '@react-aria/textfield'

export interface WithCounter {
  counter?: string
}

export type TextFieldSize = 'md' | 'lg' | 'xl'
export interface TextFieldProps<T> extends Omit<AriaTextFieldOptions<any>, 'onChange'> {
  onChange: ChangeEventHandler<T>
  className?: string
  wrapperClassName?: string
  inputClassName?: string
  errorCustomClassName?: string
  rows?: number
  size?: TextFieldSize
  frontIcon?: ReactNode
  labelClassName?: string
  validMessage?: string
  doneOnEnter?: boolean
}

export interface TextFieldWithCounterProps<T> extends TextFieldProps<T>, WithCounter {}

export const useTextFieldCounter = <T,>({ onChange, ...props }: TextFieldProps<T>): TextFieldWithCounterProps<T> => {
  const [, setCount] = useState(props.value?.length || 0)

  const handleChange = useCallback(
    (e: any) => {
      setCount(e.target.value?.length || 0)
      onChange(e)
    },
    [onChange],
  )

  return {
    ...props,
    onChange: handleChange,
    counter: props.maxLength ? `${props.maxLength} character limit` : undefined,
  }
}
